import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import pagination from '../../utils/pagination';
import Input from 'components/Input';
import Button from 'components/Button';
import { FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';
import { useModal } from 'hooks/modal';
import { Form } from '@unform/web';

import { Pagination as PaginationComponent, Item, PageButton } from './styles';

const Pagination = ({ total, activePage = 1, onClick }) => {
  const { showModal, hideModal } = useModal();

  const handleSubmit = useCallback(
    data => {
      hideModal();
      onClick(Number(data.page));
    },
    [hideModal, onClick, total],
  );

  const handleModal = useCallback(() => {
    const ModalContent = () => {
      const [disabled, setDisabled] = useState(true);

      return (
        <Form onSubmit={handleSubmit}>
          <Input
            name="page"
            placeholder=""
            onChange={e => {
              const value = Number(e.target?.value);
              setDisabled(!(value >= 1 && value <= total)); // only enable for valid range
            }}
          />
          <Button type="submit" color="primary" disabled={disabled}>
            CONFIRMAR
          </Button>
        </Form>
      );
    };

    showModal({
      title: 'Selecionar Página',
      component: <ModalContent />,
      width: '15vw',
    });
  }, [handleSubmit, showModal]);
  return (
    <PaginationComponent>
      <Item onClick={() => (activePage > 1 ? onClick(activePage - 1) : '')}>
        <PageButton disabled={activePage === 1 || total === 0}>
          <FiChevronsLeft />
        </PageButton>
      </Item>
      {pagination({ total, activePage }).map((page, index) => (
        <Item
          key={index}
          onClick={() => (page === '...' ? handleModal(total) : onClick(page))}
        >
          <PageButton $active={page === activePage}>{page}</PageButton>
        </Item>
      ))}
      <Item onClick={() => (activePage < total ? onClick(activePage + 1) : '')}>
        <PageButton disabled={activePage === total || total === 0}>
          <FiChevronsRight />
        </PageButton>
      </Item>
    </PaginationComponent>
  );
};

Pagination.propTypes = {
  total: PropTypes.number,
  activePage: PropTypes.number,
  onClick: PropTypes.func,
};

export default Pagination;
